import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { settingsController } from '../SettingsController';
import { MultimonSection } from './MultimonSection';
import { getFlagValue } from '../feature_flags';

const Row = ({ id, label, hint, checked, onChange }) => (
  <div className="setting-row" onClick={() => document.getElementById(id).click()}>
    <span className="set-text">
      <span className="set-label">{label}</span>
      {hint && <span className="set-hint">{hint}</span>}
    </span>
    <span className="custom-control custom-switch set-switch" onClick={e => e.stopPropagation()}>
      <input className="custom-control-input" type="checkbox" id={id}
        value={id} checked={checked} onChange={onChange} aria-label={label} />
      <label className="custom-control-label" htmlFor={id}></label>
    </span>
  </div>
);

export const WindowsSettings = observer(() => {
  const s = settingsController.getSettings();
  const [udpFlag, setUdpFlag] = useState(false);

  // Set default value for autoUpdate to true if not previously set
  useEffect(() => {
    if (s.autoUpdate === undefined) settingsController.toggleOptionByValue('autoUpdate', true);
  }, []);

  useEffect(() => {
    const refetch = () => getFlagValue('van550_rdp_udp_relay', false).then(setUdpFlag).catch(() => setUdpFlag(false));
    refetch();
    window.$('#settings-modal').on('show.bs.modal', refetch);
    return () => window.$('#settings-modal').off('show.bs.modal', refetch);
  }, []);

  const toggle = e => settingsController.toggleOptionByValue(e.target.value);

  return (
    <div className="settings-v2">
      <div className="set-sec"><i className="fa fa-desktop" aria-hidden="true"></i><span>Remote Desktop (RDP)</span><i className="rule"></i></div>
      <div className="set-card">
        <Row id="useRDP" label="Always use RDP" hint="Connect over RDP by default." checked={s.useRDP} onChange={toggle} />
        <Row id="useNetworkIP" label="Use Private Network IP" checked={s.useNetworkIP} onChange={toggle} />
        {udpFlag &&
          <Row id="useUdpRelay" label="Use UDP" hint="Falls back to TCP if UDP isn't available." checked={s.useUdpRelay} onChange={toggle} />}
        <Row id="useMultimon" label="Use Multimonitor" hint="Use more than one of your monitors in the session." checked={s.useMultimon} onChange={toggle} />
        {s.useMultimon && <MultimonSection />}

        <details className="set-adv">
          <summary>
            <i className="fa fa-sliders" aria-hidden="true"></i>
            <span className="set-text"><span className="set-adv-t">Advanced RDP parameters</span>
              <span className="set-adv-s">Edit the .rdp template used for every connection</span></span>
            <i className="fa fa-chevron-down set-adv-chev" aria-hidden="true"></i>
          </summary>
          <div className="set-actions">
            {window.api.isWindowsOS &&
              <button className="set-btn set-btn--primary" onClick={() => window.api.default_rdp_configurator()}>Edit parameters…</button>}
            <button className="set-btn set-btn--ghost" onClick={() => window.api.default_rdp_explorer()}>Show file</button>
          </div>
          {window.api.isWindowsOS
            ? <p className="set-hint-p">In the popup, change the values and click <strong>Save</strong> (Connection settings → General). Its <strong>Connect</strong> button won't do anything here — that's expected.</p>
            : <p className="set-hint-p">Edit this file with a text editor.</p>}
          <div className="set-actions"><button className="set-btn set-btn--link" onClick={() => window.api.default_rdp_reset()}>Reset to defaults</button></div>
        </details>
      </div>

      <div className="set-sec"><i className="fa fa-refresh" aria-hidden="true"></i><span>Automatic Updates</span><i className="rule"></i></div>
      <div className="set-card">
        <Row id="autoUpdate" label="Automatically download & install updates"
          hint="Mandatory updates still install even when this is off."
          checked={s.autoUpdate}
          onChange={e => {
            settingsController.toggleOptionByValue(e.target.value);
            // Trigger update check immediately if enabled
            if (e.target.checked) window.api.updateApp();
          }} />
      </div>
    </div>
  );
});
